import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
} from "..";

import "./styles.css";

const GeneralInfo = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );
  const studentProfile = useSelector(
    (state) => state?.students?.student?.common
  );
  const [state, setState] = useState({
    middleName: "",
    dateOfBirth: "",
    citizenships: [],
  });

  useEffect(() => {
    setState({
      middleName: questionnaire?.middleName ?? "",
      dateOfBirth: questionnaire?.dateOfBirth ?? null,
      citizenships: questionnaire?.citizenships ?? [],
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <div className="grid grid-cols-2 gap-x-7 gap-y-6">
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="First Name"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            placeholder="Enter your first name"
            value={studentProfile?.firstName}
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel text="Middle Name" />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            onChange={(e) => setState({ ...state, middleName: e.target.value })}
            placeholder="Enter your middle name"
            value={state?.middleName}
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Last Name"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            placeholder="Enter your last name"
            value={studentProfile?.lastName}
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Primary Email"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            placeholder="Enter your primary email"
            value={studentProfile?.email}
            type="email"
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Phone Number"
            required
          />
          <Spacer height="0.3125em" />
          <inputFields.DefaultPhoneInput
            placeholder="Enter your phone number"
            value={studentProfile?.phoneNumber}
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Date of Birth"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={
              state?.dateOfBirth
                ? moment(state?.dateOfBirth).format("YYYY-MM-DD")
                : null
            }
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel text="Gender" required />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            placeholder="Enter your gender"
            value={studentProfile?.student?.gender}
            disabled
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Citizenship(s)"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={state?.citizenships?.map((item, index) => (
              <span
                className="p-2 bg-liteBoxBg border border-liteBoxBorder mr-2 rounded-lg"
                key={index}
              >
                {item}
              </span>
            ))}
          />
        </div>
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="LinkedIn"
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            placeholder="Enter your liknedIn url"
            value={studentProfile?.student?.linkedIn}
            disabled
          />
        </div>
      </div>
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Address")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default GeneralInfo;
